module.exports = __webpack_public_path__ + "img/qr_code.822cde7b.png";